"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.42236 17.85449",
    width: "54.42236",
    height: "17.85449",
    fill: "#93c01f"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "22.648 14.404 22.648 3.451 31.775 8.927 22.648 14.404"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.09528.22037A.73828.73828,0,0,0,53.399.14127L49.38611,1.71183A8.17749,8.17749,0,0,0,45.45765.71256H8.9646a8.16991,8.16991,0,0,0-4.01892,1.0542L1.03717.14713A.74918.74918,0,0,0,.00006.83951V17.06608a.7502.7502,0,0,0,.75.75H53.67243a.7502.7502,0,0,0,.75-.75V.83951A.74939.74939,0,0,0,54.09528.22037ZM52.92243,1.93815V5.51334A8.22787,8.22787,0,0,0,50.857,2.74662Zm-7.46478.27441a6.71466,6.71466,0,0,1,0,13.42932H8.9646a6.71466,6.71466,0,0,1,0-13.42932Zm-41.94617.583A8.2242,8.2242,0,0,0,1.50006,5.51285V1.96256ZM1.50006,12.34171a8.23376,8.23376,0,0,0,3.89283,3.97437H1.50006Zm47.5293,3.97437a8.23375,8.23375,0,0,0,3.89307-3.97486v3.97486Z"
  }));
};

exports["default"] = _default;